import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http'
import { SortColumn, SortDirection } from '@app/directives/sortable-header.directive'
import { Observable } from 'rxjs'

export class Response {
	id: string
	cause?: any
	status?: string
	message?: string
	[key: string]: any
}

export abstract class ApiService<S> {
	protected constructor(public http: HttpClient) {}

	set uri(uri: string) {
		this._uri = uri.startsWith('/') ? uri : `/${uri}`
	}

	abstract get url(): string

	size = 10
	searchTerm: S
	sortColumn: SortColumn

	abstract sortDirection: { [key: string]: SortDirection }

	private _uri: string | undefined

	static updateHeaders(request: HttpRequest<any>, params?: { [key: string]: string }): HttpHeaders {
		let headers = new HttpHeaders(params)

		try {
			request.headers.keys().forEach((key: string) => {
				const header = request.headers.get(key)
				if (header) headers = headers.set(key, header)
			})
		} catch (e) {
			console.error(e.message)
		}

		return headers
	}

	get<R>(uri: string, params?: HttpParams, headers?: HttpHeaders): Observable<R> {
		this.uri = uri
		return this.http.get<R>(`${this.url}${this._uri}`, {
			params,
			headers
		})
	}

	put<T, R>(uri: string, body?: T, params?: HttpParams, headers?: HttpHeaders): Observable<R> {
		this.uri = uri
		return this.http.put<R>(`${this.url}${this._uri}`, body, {
			params,
			headers
		})
	}

	patch<T>(uri: string, body?: T, params?: HttpParams, headers?: HttpHeaders): Observable<Response | any> {
		this.uri = uri
		return this.http.patch<Response>(`${this.url}${this._uri}`, body, {
			params,
			headers
		})
	}

	post<T, R>(uri: string, body?: T, params?: HttpParams, headers?: HttpHeaders): Observable<R> {
		this.uri = uri
		return this.http.post<R>(`${this.url}${this._uri}`, body, {
			params,
			headers
		})
	}

	delete<R>(uri: string, params?: HttpParams, headers?: HttpHeaders): Observable<R> {
		this.uri = uri
		return this.http.delete<R>(`${this.url}${this._uri}`, {
			params,
			headers
		})
	}

	getStreaming(uri: string, params?: HttpParams, headers?: HttpHeaders) {
		this.uri = uri
		return this.http.get(`${this.url}${this._uri}`, { params, headers, responseType: 'arraybuffer' })
	}

	params(params?: HttpParams) {
		const page = params && params.get('page') ? params.get('page') : 0
		const size = params && params.get('size') ? params.get('size') : this.size

		let newParams = new HttpParams()

		params?.keys().forEach(key => {
			if (key !== 'page' && key !== 'size' && key !== 'sort' && key !== 'order') {
				const values = params.getAll(key) || []
				values.forEach(value => {
					newParams = newParams.append(key, value)
				})
			}
		})

		newParams = newParams.set('page', page).set('size', size)

		if (this.sortColumn) {
			if (this.sortDirection[this.sortColumn] !== '') {
				const sort = `${this.sortColumn},${this.sortDirection[this.sortColumn]}`
				newParams = newParams.append('sort', sort)
			}
		} else {
			newParams = newParams.delete('sort').delete('order')
		}

		return newParams
	}
}
